// Shared Tailwind class constants for ResortGeneralInfo.

export const mainClass = [
  'flex-1 mb-5 pl-[19px] max-h-fit',
  'max-md:mb-[25px] max-md:pl-0',
].join(' ');

export const resortInfoClass = [
  'mt-[30px]',
  'md:mt-0',
].join(' ');

export const grayContainerClass = [
  'bg-[#EEEEEE99] rounded-[20px] px-7 py-6',
  'max-xl:px-[18px] max-xl:py-3',
].join(' ');

export const secondLineContainerClass = [
  'my-6',
  'first:mr-6',
  'max-sm:first:mr-0 max-sm:first:mb-0',
].join(' ');

export const rowClass = [
  'flex flex-row justify-between flex-1',
  '[&_.row-start]:items-start [&_.row-start_svg]:mr-[15px] [&_.row-start_svg]:fill-none',
  '[&_.row-end]:items-end',
].join(' ');

export const smColClass = 'max-sm:flex-col';

export const columnClass = 'flex flex-col flex-1';

export const columnHeaderClass = 'uppercase font-normal text-base tracking-[2px]';

export const mainTextClass = [
  'font-bold text-dark-blue',
  'text-[clamp(1.5rem,1.8vw,1.75rem)]',
].join(' ');

export const greenMainTextClass = '!text-primary-summer';

export const secondaryTextClass = [
  'font-medium text-[#666666] uppercase tracking-[1px] text-sm',
].join(' ');

export const flex1Class = '!flex-1';
export const columnInnerClass = 'flex-none';

// Best known section
export const bestKnownClass = 'mt-4';

export const bestKnownContainerClass = [
  'bg-dark-blue rounded-[20px] px-[38px] py-[26px]',
  'max-sm:px-[19px] max-sm:py-[13px]',
  '[&_ul]:m-0 [&_ul]:p-0',
  '[&_li]:tracking-[1px] [&_li]:text-white [&_li]:mt-2.5 [&_li]:list-none',
  '[&_li]:pb-2.5 [&_li]:border-b [&_li]:border-[#CCCCCC4D]',
  '[&_li:last-of-type]:border-0 [&_li:last-of-type]:pb-0',
  '[&_li_div]:flex [&_li_div]:items-center',
  '[&_li_div_span]:mr-3',
].join(' ');

export const bestKnownHeaderClass = [
  'text-white font-medium uppercase tracking-[2px]',
  'text-[clamp(1rem,1.25vw,1.25rem)]',
].join(' ');
